module.exports = __webpack_public_path__ + "static/media/ai-card.6a2d71c7.svg";